import { ForgotView } from "~/views";
import { ForgotModel } from "~/models";

import type {
  ActionFunction,
  LoaderFunction,
  MetaFunction,
} from "@remix-run/node";

export const meta: MetaFunction = () => ({
  title: "pac.app | Forgot",
});

export const loader: LoaderFunction = async ({ request }) => {
  return await ForgotModel.LoaderController(request);
};

export const action: ActionFunction = async ({ request }) => {
  return await ForgotModel.ActionController(request);
};

export default function () {
  return <ForgotView />;
}
